import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {observer} from "mobx-react-lite";
import {notificationStore} from "../../stores/init";
import {NotificationAlertActions} from "./NotificationAlertActions";

export const RootNotificationComponent: React.FC = observer(() => {
    const handleClose = (_event?: unknown, reason?: string) => {
        if (reason === 'clickaway') return;
        if (notificationStore.active) {
            notificationStore.hide(notificationStore.active.id);
        }
    };

    const active = notificationStore.active;
    return <Snackbar
        key={active?.id}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        open={Boolean(active) && !active!.closed && !active!.hidden}
        autoHideDuration={active?.autoHideDuration ?? null}
        onClose={handleClose}
    >
        <Alert
            severity={active?.severity || 'warning'}
            variant="filled"
            sx={{width: '100%'}}
            action={
                <NotificationAlertActions
                    actionText={active?.actionText}
                    onAction={active?.onAction}
                    onClose={handleClose}
                />
            }
        >
            {active?.message}
        </Alert>
    </Snackbar>;
});
